import { InsightsAdvancedTypes } from "./insightAdvanceTypes";

export const initialState:InsightsAdvancedTypes = {
  fetching: false,
  success: null,
  error: null,
  statusCode: null,
  insightsAdvancedListData:[],
  profitLossData:[],
  totelSales:[],
  totelExpense:[],
  profitLossFetching:false,
  totalSalesFetching:false,
  totalExpenseFetching:false
}